import exchangeApiDefinition from './api/index.js';
import { exchangeQuotesAtomDefinition, exchangeRemoteConfigAtomDefinition, exchangeStatusAtomDefinition, exchangeAvailabilityAtomDefinition, exchangeableAssetsAtomDefinition, } from './atoms/index.js';
import exchangeModuleDefinition from './modules/index.js';
import exchangeDefinition from './modules/exchange.js';
import exchangeAssetsModuleDefinition from './modules/exchange-assets.js';
import exchangeFeesModuleDefinition from './modules/exchange-fees.js';
import exchangeLimitsModuleDefinition from './modules/exchange-limits.js';
import exchangeProvidersDefinition from './modules/exchange-providers.js';
import exchangeQuotesModuleDefinition from './modules/exchange-quotes.js';
import exchangeAssetAvailabilityDefinition from './modules/exchange-asset-availability.js';
import exchangeAvailabilityModuleDefinition from './modules/exchange-availability.js';
import exchangeTracerModuleDefinition from './modules/exchange-tracer.js';
import exchangeTxSimulatorModuleDefinition from './modules/exchange-tx-simulator.js';
import exchangePluginDefinition from './plugin/index.js';
import exchangeAnalyticsPluginDefinition from './plugin/exchange-analytics-plugin.js';
import exchangeReportDefinition from './report/index.js';
const exchange = (config = Object.create(null)) => ({
    id: 'exchange',
    definitions: [
        { definition: exchangeRemoteConfigAtomDefinition },
        { definition: exchangeQuotesAtomDefinition },
        { definition: exchangeStatusAtomDefinition },
        { definition: exchangeAvailabilityAtomDefinition },
        { definition: exchangeableAssetsAtomDefinition },
        { definition: exchangeAssetAvailabilityDefinition, config },
        { definition: exchangeFeesModuleDefinition },
        { definition: exchangeTracerModuleDefinition },
        { definition: exchangeProvidersDefinition, config },
        { definition: exchangeAssetsModuleDefinition, config },
        { definition: exchangeDefinition, config },
        { definition: exchangeAvailabilityModuleDefinition },
        { definition: exchangeLimitsModuleDefinition },
        { definition: exchangeQuotesModuleDefinition },
        { definition: exchangeModuleDefinition },
        { definition: exchangeApiDefinition },
        { definition: exchangePluginDefinition },
        { definition: exchangeReportDefinition },
        { definition: exchangeTxSimulatorModuleDefinition },
        {
            if: { registered: ['analytics'] },
            definition: exchangeAnalyticsPluginDefinition,
        },
    ],
});
export default exchange;
